import React from 'react';
import SomethingWentWrong from '@stencil/something-went-wrong';
import { defaultTheme } from '@stencil/build-theme';
import pushToNewrelic from '@stencil/send-data-to-new-relic';

import * as Sentry from '@sentry/react';

interface AppErrorBoundaryProps {
  children: React.ReactNode;
  appName?: string;
  SomethingWentWrongComponent?: (...args: any) => JSX.Element;
}

const AppErrorBoundary: React.FC<AppErrorBoundaryProps> = ({
  children,
  appName,
  SomethingWentWrongComponent
}) => {
  const containerHeight = '100vh';

  let FinalSomethingWentWrongComponent = () => (
    <SomethingWentWrong
      headingStyles={{
        fontFamily: defaultTheme.font.fontFamily
      }}
      containerStyles={{
        height: containerHeight
      }}
      actionTextStyles={{
        fontFamily: defaultTheme.font.fontFamily
      }}
    />
  );

  if (SomethingWentWrongComponent) {
    FinalSomethingWentWrongComponent = SomethingWentWrongComponent;
  }

  return (
    <Sentry.ErrorBoundary
      fallback={FinalSomethingWentWrongComponent}
      onError={error => console.log(`${appName} se :`, error)}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default AppErrorBoundary;

// export default class AppErrorBoundary extends React.Component<AppErrorBoundaryProps> {
//   constructor(props) {
//     super(props);
//     this.state = {
//       hasError: false
//     };
//   }

//   static getDerivedStateFromError(error) {
//     return {
//       hasError: true
//     };
//   }

//   componentDidCatch(error, errorInfo) {
//     // pushToNewrelic(this.props.appName, error);
//     if (process.env.BUILD_ENV === 'prod' && Sentry) {
//       Sentry.withScope(scope => {
//         Object.keys(errorInfo).forEach(key => {
//           scope.setExtra(key, errorInfo[key]);
//         });
//         Sentry.captureException(error);
//       });
//     }
//   }

//   render() {
//     /** 75 is magic number for height of header. Since it'll take figuring
//      * out how to pass a ref from here to header, keeping it a magic number for now
//      */
//     const containerHeight = `calc(100vh - ${75}px)`;

//     const FinalSomethingWentWrongComponent = () => (
//       <SomethingWentWrong
//         headingStyles={{
//           fontFamily: defaultTheme.font.fontFamily
//         }}
//         containerStyles={{
//           height: containerHeight
//         }}
//         actionTextStyles={{
//           fontFamily: defaultTheme.font.fontFamily
//         }}
//       />
//     );

//     if (this.props.SomethingWentWrongComponent) {
//       return <this.props.SomethingWentWrongComponent />;
//     }

//     return (
//       <Sentry.ErrorBoundary
//         fallback={FinalSomethingWentWrongComponent}
//         onError={error => console.log(error)}
//       >
//         {this.props.children}
//       </Sentry.ErrorBoundary>
//     );

//     // if (this.state.hasError) {
//     //   if (this.props.SomethingWentWrongComponent) {
//     //     return <this.props.SomethingWentWrongComponent />;
//     //   }

//     //   return (
//     //     <SomethingWentWrong
//     //       headingStyles={{
//     //         fontFamily: defaultTheme.font.fontFamily
//     //       }}
//     //       containerStyles={{
//     //         height: containerHeight
//     //       }}
//     //       actionTextStyles={{
//     //         fontFamily: defaultTheme.font.fontFamily
//     //       }}
//     //     />
//     //   );
//     // }

//     // return this.props.children;
//   }
// }

// type ComponentType = React.FC<AppErrorBoundaryProps>;

// export function withAppErrorBoundary(
//   Component: ComponentType,
//   appBoundaryProps?: AppErrorBoundaryProps
// ) {
//   return function (props: any) {
//     return (
//       <AppErrorBoundary {...appBoundaryProps}>
//         <Component {...props} />
//       </AppErrorBoundary>
//     );
//   };
// }
